import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
export const LazyUserNotifications = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-user-notifications", jiraSpaEntry: "async-jira-eoc-user-notifications" */ '@atlassian/jira-eoc-user-notifications'
		),
	{ ssr: false },
);

const LazyUserNotificationsPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyUserNotifications}
		pageId="async-eoc-user-notifications"
		shouldShowSpinner={false}
	/>
);

export default LazyUserNotificationsPage;
